export default __webpack_public_path__ + "static/media/mastercard.5873e7b7.svg";